(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .factory('AppVersion', AppVersion)
      .directive('tfcAppVersion', tfcAppVersion);

  // @ngInject
  function AppVersion($q) {

    var appVersion = '';
    var appCopyright = '';

    function extractMetadata(response) {
      var version = response.headers('X-Application-Version');
      if (version) {
        appVersion = version;
      }
      var copyright = response.headers('X-Application-Copyright');
      if (copyright) {
        appCopyright = copyright;
      }
    }

    return {
      getAppVersion : function () { return appVersion; },
      getAppCopyright : function () { return appCopyright; },
      // response interceptor
      response : function (response) {
        extractMetadata(response);
        return response;
      },
      responseError : function (response) {
        extractMetadata(response);
        return $q.reject(response);
      }
    };
  }

  // @ngInject
  function tfcAppVersion(AppVersion) {
    return {
      scope : {},
      templateUrl : 'Nav/AppVersion.tmpl.html',
      link : function ($scope) {
        $scope.getAppVersion = AppVersion.getAppVersion;
        $scope.getAppCopyright = AppVersion.getAppCopyright;
      }
    };
  }

})();
